import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { TextRow } from 'components';
import { renderStaffName } from 'utils';

export const SelectedStaffs = ({}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;

    return (
        <div style={{ width: 170, minWidth: 170 }}>
            <div className="selected-staffs-count">
                <p>Selected Staff</p>
                <div>{info?.staffFull?.length}</div>
            </div>

            <div className="selected-staffs-body">
                {info?.staffFull?.map((i, j) => (
                    <div key={j} className="selected-staffs-info-wrapper">
                        <div className="selected-staffs-avatar-box">
                            {i?.avatar ? <img src={i?.avatar} alt={''} /> : `${i?.firstName?.slice(0, 1)}${i?.lastName?.slice(0, 1)}`}
                        </div>
                        <div>
                            <div className="selected-staff-name">
                                <TextRow name={renderStaffName(i)} textWidth={7} />
                            </div>
                            {i?.jobTitle?.name && (
                                <div className="selected-staff-job">
                                    <TextRow name={i?.jobTitle?.name} textWidth={6} color={'#7A7C7E'} />
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
